import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageCkeck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"package-ckeck,delivery"} maskId="square-filled-radius-0-stroke-1-IconPackageCkeck"><path d="M3 21V3H8V9H16V3H21V14.4694L17.1522 18.3172L15.25 16.415L13.0672 18.5978L15.4694 21H3Z" fill="currentColor"/><path d="M15 3H9V8H15V3Z" fill="currentColor"/><path d="M17.1522 21.2686L22.2686 16.1522L21.5 15.3836L17.1522 19.7314L15.25 17.8293L14.4814 18.5978L17.1522 21.2686Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPackageCkeck;
